import { render, staticRenderFns } from "./KlarnaPaymentMethod.vue?vue&type=template&id=825f3892&scoped=true&"
import script from "./KlarnaPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./KlarnaPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825f3892",
  null
  
)

export default component.exports